/* eslint-disable no-unused-expressions */
import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { Dialog, DialogActions, DialogContent } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import LogoutIcon from '@mui/icons-material/Logout'
import { useMsal } from '@azure/msal-react'

import { Logger, LoggerTypes } from '../../../utils'
import { Button, buttonModes, buttonTypes, FormTitle } from '../../../components'
import { clearStorage } from '../../../storage/storage'

export const UserLogoutDialog = ({ setOpenDialog, className }) => {
  const { t } = useTranslation()
  const { instance } = useMsal()

  const onCloseDialog = () => setOpenDialog(false)

  const onSignout = (e) => {
    e.stopPropagation()

    Logger.trace(LoggerTypes.CONTAINER, 'UserLogoutDialog.onSignout()', {})

    // -- clear the local storage with the user's rights in cache
    clearStorage()

    instance &&
      instance
        .logoutRedirect()
        .then((res) => {
          Logger.trace(LoggerTypes.CONTROLLER, 'UserLogoutDialog.onSignout().then()', { res })
          onCloseDialog(false)
        })
        .catch((err) => {
          Logger.trace(LoggerTypes.WARN, 'UserLogoutDialog.onSignout().catch()', { err })
        })
  }

  // Logger.trace(LoggerTypes.CONTAINER, 'UserLogoutDialog.render()', {})

  return (
    <Dialog
      open={true}
      onClose={onCloseDialog} // <-- close while clicking on background
      aria-labelledby="form-dialog-title"
      maxWidth="xl"
      width="xl"
      className={`SimulationDialogLaunch ${className}`}
    >
      <DialogContent>
        <FormTitle title={t('users.signout.title')} style={{ fontSize: '20px' }} />
        <section>{t('users.signout.explanation')}</section>
      </DialogContent>
      <DialogActions>
        <Button
          mode={buttonModes.SECONDARY_ACTION}
          type={buttonTypes.BUTTON}
          text={t('common.cancel')}
          icon={<CloseIcon />}
          onClick={onCloseDialog}
        />
        <Button
          mode={buttonModes.PRIMARY_ACTION}
          type={buttonTypes.BUTTON}
          text={t('users.signout.title')}
          icon={<LogoutIcon />}
          onClick={onSignout}
        />
      </DialogActions>
    </Dialog>
  )
}

UserLogoutDialog.displayName = 'UserLogoutDialog'

UserLogoutDialog.propTypes = {
  setOpenDialog: PropTypes.func.isRequired,
  className: PropTypes.string
}

UserLogoutDialog.defaultProps = {
  setOpenDialog: () => {},
  className: ''
}
